import api from "@/lib/axiosConfig";
import { t } from "i18next";
import { z, ZodType } from "zod";
import { baseRoute } from "./documents";

export const documentSchema = z.object({
  id: z.string().optional(),
  documentsDescriptionNumeroEnregistrement: z
    .string()
    .nonempty(t("form.error.emptyField")),
  documentsDescriptionTitre: z.string(),
});

export const appendNoDuplicateRecordNumberRefine = <
  T extends {
    id?: string;
    documentsDescriptionNumeroEnregistrement: string;
  },
>(
  schema: ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateRecordNumbers(
        val.documentsDescriptionNumeroEnregistrement,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: t("form.error.document.duplicateRecordNumbers"),
      path: ["documentsDescriptionNumeroEnregistrement"],
    },
  );

export async function validateNoDuplicateRecordNumbers(
  recordNumber: string,
  id?: string,
) {
  await api.get<void>(`${baseRoute}/record-number/validate/no-duplicates`, {
    params: {
      value: recordNumber,
      id,
    },
  });
}
